import React, { Component } from 'react';
import TextFields from '../UI/TextFiled';
import { Link } from 'react-router-dom';
import { Form } from 'react-form';
import Dialog from '../UI/Dialog';
import ReactPaginate from 'react-paginate';
import SelectMenu from '../UI/Select';
import { Role } from '../../utils/constants';



class AdminUsersManagementList extends Component {

    state = {
        isDialogOpen: false,
        isEditDialogOpen: false
    };


    render() {

        return (
            <React.Fragment>
                <Dialog open={this.state.isDialogOpen} handleClose={ () => this.setState({ isDialogOpen: false }) }>
                    <Form onSubmit={ this.submitted }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Add New User</h2>
                                </div>
                                <div className="popup-body col-xs-12">
                                        <TextFields type="text"
                                                    label="Username"
                                                    field="username" />
                                        <TextFields type="password"
                                                    label="Password"
                                                    field="password" />
                                        <SelectMenu field="from" label="from" menu={ Role }/>

                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isDialogOpen: false }) }>×</button>
                </Dialog>
                <Dialog open={this.state.isEditDialogOpen} handleClose={ () => this.setState({ isEditDialogOpen: false }) }>
                    <Form onSubmit={ this.submitted }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="popup-title">
                                    <h2>Edit User</h2>
                                </div>
                                <div className="popup-body col-xs-12">
                                        <TextFields type="text"
                                                    label="Username"
                                                    field="username" />
                                        <TextFields type="password"
                                                    label="Password"
                                                    field="password" />
                                        <SelectMenu field="from" label="from" menu={ Role }/>

                                </div>
                                <div className="popup-meta flex justify-end">
                                    <button className="btn filled primary min-120">Save</button>
                                </div>
                            </form>
                        )}
                    </Form>
                    <button className="no-style close-btn" onClick={ () => this.setState({ isEditDialogOpen: false }) }>×</button>
                </Dialog>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-4">
                                <Form onSubmit={ this.submitted }>
                                    { formApi => (
                                        <form onSubmit={formApi.submitForm} className="search">
                                            <TextFields type="text" hintText="Search"/>
                                            <button className="no-style search-btn pointer">
                                                <i className="fa fa-search"></i>
                                            </button>
                                        </form>
                                    )}
                                </Form>
                            </div>

                            <div className="col-xs-4 text-center">
                                <h1 className="color-grey">Admin Users Management</h1>
                            </div>

                            <div className="col-xs-4 text-right">
                                <Link onClick={ () => this.setState({ isDialogOpen: true }) } to="#" className="btn filled primary min-180"><i className="fa fa-plus font-sm mr-10"></i>Add New User</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container box py-15">
                    <div className="table">
                        <table>
                            <thead>
                            <tr>
                                <th>Username</th>
                                <th>Password</th>
                                <th>Role</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr >
                                <td>AshotSahakyan</td>
                                <td>784-2001-1234566-1</td>
                                <td>Finance Admin</td>
                                <td>
                                    <div className="flex-center-y justify-center">
                                        <Link to="#" onClick={ () => this.setState({ isEditDialogOpen: true }) } className="px-10"><i className="fa fa-pencil"></i></Link>
                                        <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                    </div>
                                </td>
                            </tr>
                            <tr >
                                <td>AshotSahakyan</td>
                                <td>784-2001-1234566-1</td>
                                <td>Finance Admin</td>
                                <td>
                                    <div className="flex-center-y justify-center">
                                        <Link to="#" onClick={ () => this.setState({ isEditDialogOpen: true }) } className="px-10"><i className="fa fa-pencil"></i></Link>
                                        <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                    </div>
                                </td>
                            </tr>
                            <tr >
                                <td>AshotSahakyan</td>
                                <td>784-2001-1234566-1</td>
                                <td>Finance Admin</td>
                                <td>
                                    <div className="flex-center-y justify-center">
                                        <Link to="#" onClick={ () => this.setState({ isEditDialogOpen: true }) } className="px-10"><i className="fa fa-pencil"></i></Link>
                                        <Link to="#" className="px-10 color-red"><i className="fa fa-trash font-md"></i></Link>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <ReactPaginate previousLabel={<i className='fa fa-chevron-left'></i>}
                                       nextLabel={<i className='fa fa-chevron-right'></i>}
                                       breakLabel={<a href="">...</a>}
                                       breakClassName={"break-me"}
                                       pageCount={this.state.pageCount}
                                       marginPagesDisplayed={2}
                                       pageRangeDisplayed={5}
                                       containerClassName={"pagination"}
                                       subContainerClassName={"pages pagination"}
                                       activeClassName={"active"} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}



export default AdminUsersManagementList;



// WEBPACK FOOTER //
// ./src/components/Admin-users-management/AdminUsersManagementList.js